import Requests from '@frontend/services/api/file-browser';

export function hasFilesDrag(event) {
  return Array.from(event?.dataTransfer?.types || []).includes('Files');
}

export function collectDroppedFiles(items, rootFolderId, { tab } = {}) {
  const files = {};
  const folders = [];
  const itemsArray = Array.from(items || []);

  return Promise.all(itemsArray.map((item) => processItem(item, rootFolderId, files, tab, folders)))
    .then(() => {
      Object.defineProperty(files, 'folders', { value: folders, enumerable: false });
      return files;
    });
}

function processItem(item, parentID, files, tab, folders) {
  console.log('processItem called with item:', item, 'parentID:', parentID);
  const entry = item.webkitGetAsEntry();

  if (!entry) return Promise.resolve();

  if (entry.isFile) {
    return handleFile(entry, parentID, files);
  } else if (entry.isDirectory) {
    return processDirectory(entry, parentID, files, tab, folders);
  }

  return Promise.resolve();
}

function handleFile(entry, parentID, files) {
  return new Promise((resolve) => {
    entry.file((file) => {
      if (!files[parentID]) {
        files[parentID] = [];
      }
      files[parentID].push(file);
      resolve();
    });
  });
}

function processDirectory(entry, parentID, files, tab, folders) {
  const folderName = entry.name;
  return createFolder(parentID, folderName, tab)
    .then((folderId) => getFilesInFolder(entry).then((filesInFolder) => {
      folders.push({ id: folderId, name: folderName, parentId: parentID });
      files[folderId] = filesInFolder;
      return processSubFolders(entry, folderId, files, tab, folders);
    }))
    .catch((error) => {
      console.error(error);
    });
}

function createFolder(parentID, folderName, tab) {
  console.log('Creating folder:', folderName, 'under parent ID:', parentID);
  let url = '/file/create_folder_by_name';
  if (tab) url += `?tab=${tab}`;

  return Requests.createFolderByName(url, {
    parent_id: parentID,
    name: folderName,
  }).then((response) => response.data.id);
}

async function readDirectoryEntries(entry) {
  const reader = entry.createReader();
  const entries = [];

  for (;;) {
    const batch = await new Promise((resolve, reject) => reader.readEntries(resolve, reject));

    if (!batch.length) {
      return entries;
    }

    entries.push(...batch);
  }
}

async function getFilesInFolder(folderEntry) {
  const entries = await readDirectoryEntries(folderEntry);

  return Promise.all(entries.filter((entry) => entry.isFile).map((entry) => new Promise((resolve, reject) => {
    entry.file(resolve, reject);
  })));
}

async function processSubFolders(entry, parentID, files, tab, folders) {
  const entries = await readDirectoryEntries(entry);

  await Promise.all(entries.filter((subEntry) => subEntry.isDirectory).map((subEntry) => (
    processDirectory(subEntry, parentID, files, tab, folders)
  )));
}
